export default __webpack_public_path__ + "static/media/3.a0d5b188.png";